import React from "react";
import { Link } from "react-router-dom";
import "./Therapist.css";

const Therapist = ({ therapist }) => {
  // const mylink = "/dt/" + therapist.id;
  return (
    <>
      <Link to={`/dt/${therapist.id}`}>
        <div className="therapistContainer">
          <img
            src={therapist.Avatar}
            className="therapistImage"
            alt="Therapist"
          />

          <div>
            {therapist.FirstName} {therapist.LastName}
          </div>
          <div>{therapist.Phone}</div>
        </div>
      </Link>
    </>
  );
};

export default Therapist;
